<template>
  <div class="inspection--invoice">
    <v-container py-0>
      <v-layout row wrap>
        <v-flex xs12 sm4>
          <h3>
            Invoice
            <span class="invoices-id">#{{hgInvoice.id}}</span>
          </h3>
        </v-flex>

        <v-flex
          class="invoice-line"
          xs12
          sm8
          row
          wrap>
          <v-layout v-for="(service, index) in hgInvoice.services" :key="index">
            <v-flex xs12>
              <Service :service="service" />
            </v-flex>
          </v-layout>

          <v-layout class="invoice-total" row wrap>
            <v-flex xs12>
              <hr />
            </v-flex>

            <v-flex xs12>
              <InvoiceTotalRow label="Sales Tax">
                <span class="salesTax">{{currency(hgInvoice.salesTax)}}</span>
              </InvoiceTotalRow>
            <InvoiceTotalRow
              :isReverted="true"
              :label="surcharge.label"
              v-if="surcharge.enabled || false">
              <span>{{ currency( calculatedSurchargeAmount ) }}</span>
            </InvoiceTotalRow>
              <InvoiceTotalRow label="Total">
                <span class="total">{{currency( calculatedInvoiceTotal )}}</span>
              </InvoiceTotalRow>
              <InvoiceTotalRow label="Amount Paid">
                <span class="amountPaid">({{currency( calculatedAmountPaid )}})</span>
              </InvoiceTotalRow>
              <InvoiceTotalRow label="Amount Due">
                <span class="amountDue">{{currency( calculatedAmountDue )}}</span>
              </InvoiceTotalRow>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { Mixins } from '@spectorasoftware/homegauge-vue';
import { mapState } from 'vuex';
import Service from './Service.vue';
import InvoiceTotalRow from './InvoiceTotalRow.vue';
import featureFlags from '../../constants/feature-flags';

const { CurrencyFilter } = Mixins;

export default {
  data() {
    return {
    };
  },
  components: {
    InvoiceTotalRow,
    Service,
  },
  mixins: [CurrencyFilter],
  props: {
    hgInvoice: {
      required: true,
      type: Object,
    },
    surcharge: {
      type: Object,
      default: () => ({ enabled: false, value: 0, label: 'Surcharge' }),
    },
    technologyFee: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapState('unleash', {
      enabledFeatures: state => state.enabledFeatures,
    }),
    technologyFeeEnabled() {
      return this.enabledFeatures[featureFlags.TECHNOLOGY_FEE];
    },
    calculatedSurchargeAmount() {
      let fee = 0;
      if (this.technologyFeeEnabled && this.technologyFee > 0) {
        const cents = Math.round(Number(this.technologyFee) * 100);
        fee = cents / 100;
      } else if (this.surcharge.enabled) {
        const calculated = (Number(this.hgInvoice.total) * this.surcharge.value) / 100;
        const cents = Math.round(calculated * 100);
        fee = cents / 100;
      }
      return fee;
    },
    calculatedInvoiceTotal() {
      const total = Number(this.hgInvoice.total) || 0;
      const totalCents = Math.round(total * 100);
      const feeCents = Math.round(this.calculatedSurchargeAmount * 100);
      return (totalCents + feeCents) / 100;
    },
    calculatedAmountPaid() {
      const amountPaid = Number(this.hgInvoice.amountPaid) || 0;
      const paidCents = Math.round(amountPaid * 100);
      if (this.technologyFeeEnabled && this.technologyFee > 0) {
        const feeCents = Math.round(this.calculatedSurchargeAmount * 100);
        return (paidCents + feeCents) / 100;
      }
      return paidCents / 100;
    },
    calculatedAmountDue() {
      const amountDue = Number(this.hgInvoice.amountDue);
      if (Number.isNaN(amountDue)) {
        return this.hgInvoice.amountDue;
      }
      const dueCents = Math.round(amountDue * 100);
      if (this.technologyFeeEnabled && this.technologyFee > 0) {
        return dueCents / 100;
      }
      const feeCents = Math.round(this.calculatedSurchargeAmount * 100);
      return (dueCents + feeCents) / 100;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/typography';

h3 {
  font-weight: $typography-weight-normal;
  text-transform: uppercase;

  .invoices-id {
    display: block;
    font-weight: $typography-weight-bold;
  }
}

hr {
  background-color: rgba(0, 0, 0, 0.15);
  border-color: rgba(0, 0, 0, 0.15);
  border-width: 0;
  height: 1px;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
}

.invoice-line {
  line-height: 40px;
}

@media all and (max-width: 600px) {
  h3 {
    margin-bottom: 30px;
  }
}
</style>
